import React from "react";
import "./styles.scss"

const Footer: React.FC = () => {
    return (
        <footer style={styles.footer} className="footer-main-content">
            <p style={{ marginLeft: "40px" }}>
                2025 © Hospital São Marcelino Champagnat, Inc.{" "}
            </p>
            <p style={{ marginRight: "40px" }}>
                <a href="#">Política de Privacidade</a>
            </p>
        </footer>
    );
};

const styles: Record<string, React.CSSProperties> = {
    footer: {
        textAlign: "center",
        background: "#FDFCFC",
        borderTop: "1px solid #ddd",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
};

export default Footer;
